export default (barsCount = 10, percentOfProgress) => {
  const percentPerBar = 100 / barsCount;
  if (percentPerBar >= percentOfProgress) {
    return 1;
  }

  return (percentOfProgress / percentPerBar).toFixed(0);
};
